module.exports = __webpack_public_path__ + "media/images/dime-simple-money-logo-58ac894fa012cd986472bc886006effd.png";